import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import MyVacancyCard from '@/partials/VacancyCards/MyVacancyCard/MyVacancyCard.vue'

const JOBS_LIMIT = 20

export default Vue.extend<any, any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    MyVacancyCard,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState('myVacancies', {
      vacancies: (state: any) => state.completed.values,
      isLoading: (state: any) => state.completed.isLoading,
      isLoaded: (state: any) => state.completed.isLoaded,
      pagination: (state: any) => state.completed.pagination,
    }),
  },
  async created() {
    await this.load({ limit: JOBS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myVacancies/loadCompleted',
      loadMore: 'myVacancies/loadMoreCompleted',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.vacancies.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: JOBS_LIMIT, offset: this.vacancies.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
    onChangeStatus(vacancy: any, status: any) {
      this.changePostedStatus({
        jobId: vacancy.id,
        status,
      })
    },
    onChangeTab(newRoute: string) {
      this.$emit('changeTab', newRoute)
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Full-time Jobs - Archived'),
    }
  },
})
